import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getStatusList = store => store[NAME].statusList;
export const getProfileList = store => store[NAME].profileList;